import {gql, useQuery} from '@apollo/client'
import useRouteBasedSkip from '../../hooks/useRouteBasedSkip'

export default function useQueryExpiringUser() {
  const shouldSkip = useRouteBasedSkip('/adminpanel')

  const queryExpiringUser = gql`
    query expiringUser {
      expiringUsersList {
        UsersDetails {
          FIRST_NAME
          LAST_NAME
          CLIENT_NAME
          PROJECT_NAME
          CLIENT_ID
          PROJECT_ID
          END_DATE
        }
      }
    }
  `
  const {data, loading} = useQuery(queryExpiringUser, {
    context: {clientName: 'adminPanel'},
    notifyOnNetworkStatusChange: true,
    skip: shouldSkip
  })

  return {data, loading}
}
